import React, { useEffect, useContext, useState,useMemo } from "react";
import dash_icon from "../../../images/dashboard icon.svg";
import check from "../../../images/CheckCircle.svg";

import { apiCall, setIs1kViewEnabled } from "../../../utils/httpClient";
import ApiEndPoint, { HomePageEndpoints } from "../../../utils/apiEndPoints";

import { colors10, colors11, colors12 } from "../../../utils/constants";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import Loader from "react-js-loader";
import CountUpWrapper from "./CountUpWrapper";
import RollingCounter from "./RollingCounter";

import { AuthContext } from "../../../Context/context";
import { useLocation, useNavigate } from "react-router-dom";
import { SourceContext, UserDatailContext } from "../../../Context/userContext";

import { LandingImages } from "../../../utils/constants";
import Roles from "../../../utils/roles";

import CountryMarquee from "./CountryMarquee";
import Footer from "../../../Components/Footer";
import { LANDING_PAGE_STATIC_NUMBERS } from "../landingpage.constants";

import LocationMark from "../../../images/LocationMark.svg"
import { LocalStorageService, LocalStorageKeys } from "../../../utils/LocalStorageService";



const Landing = (props) => {
  const { signOutFun } = useContext(AuthContext);
  const userDetails = LocalStorageService.get(LocalStorageKeys.USER_DETAILS);

  const {
    lungClicked,
    setLungClicked,
    is1kViewEnabled,
    setIs1kViewEnabled: setIs1kViewEnabledContext,
  } = useContext(SourceContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [scrolled, setScrolled] = useState(false);
  //edited
  // const [selectedCountry, setSelectedCountry] = useState("");

  const {
    treatmentDetails,
    drugTherapy,
    biologicalTherapy,
    top10Cancersite,
    proteomics,
    totalPatientCount,
    primaryCanSite,
    drugTotal,
    multiModal,
    top10BioMarkers,
  } = props;

  const countrieslist = useMemo(
    () => [
      "Venezuela",
      "Philippines",
      "Bangladesh",
      "Turkey",
      "India",
      "Nepal",
      "Sri Lanka",
      "Argentina",
      "Costa Rica",
      "Malaysia",
      "UAE",
      "USA",
      "Mexico",
      "Peru",
      "Panama",
      "Uzbekistan",
      "Iran",
      "Russia",
    ],
    []
  );

const countryImages = useMemo(() => { return {
  Venezuela: LandingImages.Venezuela,
  Philippines: LandingImages.Philippines,
  Bangladesh: LandingImages.Bangladesh,
  Turkey: LandingImages.Turkey,
  India: LandingImages.India,
  Nepal: LandingImages.Nepal,
  "Sri Lanka": LandingImages.SriLanka,
  Argentina: LandingImages.Argentina,
  "Costa Rica": LandingImages.CostaRica,
  Malaysia: LandingImages.Malaysia,
  UAE: LandingImages.UAE,
  USA: LandingImages.USA,
  Mexico: LandingImages.Mexico,
  Peru: LandingImages.Peru,
  Panama: LandingImages.Panama,
  Uzbekistan: LandingImages.Uzbekistan,
  Iran: LandingImages.Iran,
  Russia: LandingImages.Russia
}
},[]);

  const [patientCountMap, setPatientCountMap] = useState(new Map());
  const { bannerCategories, bannerSeriesData } = useMemo(() => {
    if (!patientCountMap.size) {
      return { bannerCategories: [], bannerSeriesData: [] };
    }
    const today = new Date();
    const months = [];
    for (let i = 5; i >= 0; i--) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}`;
      months.push({ date: d, key });
    }
    const categories = months.map(
      ({ date }) =>
        `${date.toLocaleString("en", { month: "short" })} '${date
          .getFullYear()
          .toString()
          .slice(2)}`
    );

    const seriesData = months.map(
      ({ key }) => Number(patientCountMap.get(key)) || 0
    );

    return {
      bannerCategories: categories,
      bannerSeriesData: seriesData,
    };
  }, [patientCountMap]);

  /* ----------------------------------------
     URL Based State Sync
  ---------------------------------------- */
  useEffect(() => {
    if (location.pathname === "/") {
      setLungClicked(false);      
      setIs1kViewEnabledContext(false);
      setIs1kViewEnabled(false);
    } else if (location.pathname === "/Lung") {
      setLungClicked(true);      
      setIs1kViewEnabledContext(false);
      setIs1kViewEnabled(false);
    } else if (location.pathname === "/demo1k") {      
      setLungClicked(false);
      setIs1kViewEnabledContext(true);
      setIs1kViewEnabled(true);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  /* ----------------------------------------
     Role Based Routing
  ---------------------------------------- */
  useEffect(() => {
    if (userDetails?.role === Roles.GUEST_ANALYST) {
      if (
        location.pathname === "/Dashboard" ||
        location.pathname === "/Lung" ||
        location.pathname === "/demo1k"
      ) {
        logout();
      }
    } else if (userDetails?.role === Roles.DOCTOR_ANALYST) {
      if (
        location.pathname === "/Lung" ||
        location.pathname === "/demo1k"
      ) {
        logout();
      }
    }
    // eslint-disable-next-line
  }, [location.pathname, userDetails]);

  useEffect(() => {
    const handlePatientCountApi = async () => {
      const params = { months: 6 };
      const patientCountRes = await apiCall(
        "GET",
        `${ApiEndPoint.monthlyPatientData}?months=${params.months}`
      );
      if (!patientCountRes || !patientCountRes?.data?.payLoad) return;
      const normalizedMap = new Map(
        Object.entries(patientCountRes.data.payLoad).map(([key, value]) => {
          const date = new Date(key + "-01");
          const normalizedKey = `${date.getFullYear()}-${String(
            date.getMonth() + 1
          ).padStart(2, "0")}`;
          return [normalizedKey, value];
        })
      );

      setPatientCountMap(normalizedMap);
    };

    handlePatientCountApi();
  }, []);
 

  const logout = () => {
    navigate("/login");
    signOutFun();
  };

  /* ----------------------------------------
     Navigation Buttons
  ---------------------------------------- */
  const handleLungClick = () => {
    if (!lungClicked) {
      setLungClicked(true);
      navigate("/Lung");
    } else {
      setLungClicked(false);
      navigate("/");
    }
  };

  const handlePathologyClick = () => {
    if (!is1kViewEnabled) {
      setLungClicked(false);
      setIs1kViewEnabledContext(true);
      setIs1kViewEnabled(true);
      navigate("/demo1k");
    } else {
      setLungClicked(false);
      setIs1kViewEnabledContext(false);
      setIs1kViewEnabled(false);
      navigate("/");
    }
  };

  const handleDashboardClick = () => {
    setIs1kViewEnabledContext(false);
    setIs1kViewEnabled(false);
    setLungClicked(false);
    navigate("/Dashboard");
  };

  // LUNG_ANALYST gets the LuNGS Alliance view in place of the Dashboard
  const handleLungsAllianceClick = () => {
    setIs1kViewEnabledContext(false);
    setIs1kViewEnabled(false);
    setLungClicked(true);
    navigate("/Lung");
  };

  /* ----------------------------------------
     Header Scroll Shrink
  ---------------------------------------- */
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ----------------------------------------
     Highcharts Options (3 Pie Charts)
  ---------------------------------------- */
  const chartOptions = {
    accessibility: { enabled: false },
    chart: { type: "pie" },
    title: { text: null },
    subtitle: { text: null },
    tooltip: {
      backgroundColor: "none",
      borderRadius: 0,
      shadow: false,
      useHTML: true,
      borderWidth: 0,
      formatter() {
        return `
          <div style="background-color:${this.point.color}">
            ${this.point.name}: ${this.y}<br/>${Math.round(
          this.point.percentage
        )}%
          </div>`;
      },
      style: { color: "white" },
    },
    legend: { enabled: false },
    credits: { enabled: false },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        size: "90%",
        innerSize: "60%",
        borderRadius: 2,
        borderWidth: 5,
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%",
          distance: -30,
          style: { fontSize: "0.9em", color: "#fff", textOutline: "none" },
        },
      },
      series: { dataLabels: { enabled: false }, showInLegend: false },
    },
    colors: drugTherapy.map((e, i) => colors11[i % colors11.length]),
    series: [
      {
        name: "Patients",
        colorByPoint: true,
        data: drugTherapy.map((item) => ({
          name: item.name,
          y: item.value,
        })),
      },
    ],
  };

  /* Second Pie Chart */
  const chartOptions1 = {
    ...chartOptions,
    colors: treatmentDetails.map((e, i) => colors10[i % colors10.length]),
    series: [
      {
        name: "Patients",
        colorByPoint: true,
        data: treatmentDetails.map((i) => ({
          name: i.name,
          y: i.value,
        })),
      },
    ],
  };

  /* Third Pie Chart */
  const chartOptions2 = {
    ...chartOptions,
    colors: biologicalTherapy.map((e, i) => colors12[i % colors12.length]),
    series: [
      {
        name: "Patients",
        colorByPoint: true,
        data: biologicalTherapy.map((i) => ({
          name: i.name,
          y: i.value,
        })),
      },
    ],
  };

  /* ----------------------------------------
     Banner Line Chart
  ---------------------------------------- */
  const bannerLinechart = {
    chart: {
      backgroundColor: "transparent",
      type: "line",
      marginBottom: 30,
      marginTop: 0,
      // width: 380,
      // height:260,
      events: {
        load() {
          const chart = this;
          chart.renderer.definition({
            tagName: "filter",
            id: "marker-glow",
            children: [
              {
                tagName: "feGaussianBlur",
                attributes: { stdDeviation: 6, result: "blur" },
              },
              {
                tagName: "feMerge",
                children: [
                  { tagName: "feMergeNode", attributes: { in: "blur" } },
                  {
                    tagName: "feMergeNode",
                    attributes: { in: "SourceGraphic" },
                  },
                ],
              },
            ],
          });
        },
      },
    },

    title: { text: "" },

    xAxis: {
      categories: bannerCategories,
      tickLength: 0,
      tickWidth: 0,
      labels: {
        rotation: 0,
        autoRotation: false,
        step: 1,
        align: "center",
        y: 18,
        style: {
          color: "#FFFFFF",
          fontSize: "0.75rem",
          fontWeight: 700,
          whiteSpace: "nowrap",
        },
      },
      lineColor: "#F0F0F0",
    },

    yAxis: { visible: false },

    tooltip: {
      useHTML: true,
      borderWidth: 0,
      shadow: false,
      backgroundColor: "transparent",
      formatter() {
        const monthIndex = this.point.index; // 0–5
        const today = new Date();
        const d = new Date(
          today.getFullYear(),
          today.getMonth() - (5 - monthIndex),
          1
        );

        const fullMonth = d.toLocaleString("en", { month: "long" });

        return `
      <div class="my-tooltip-box">
        <div class="tooltip_count">${this.y}</div>
        <div class="tooltip_month">${fullMonth}</div>
      </div>`;
      },
    },

    credits: { enabled: false },

    series: [
      {
        type: "area",
        data: bannerSeriesData,
        // data: [4000, 6000, 7500, 8200, 10000, 11100],
        showInLegend: false,
        color: "#FFFFFF",
        lineWidth: 3,
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(255,255,255,0.25)"],
            [0.5, "rgba(10,123,207,0.25)"],
            [1, "rgba(10,123,207,0)"],
          ],
        },
        marker: {
          radius: 5,
          fillColor: "#FFFFFF",
          lineWidth: 1,
          lineColor: "transparent",
        },
      },
    ],
  };


  const biobankMetrics = useMemo(
  () => [
    { label: "Whole Slide Images (H&E)", value: LANDING_PAGE_STATIC_NUMBERS.bioBank.WSI },
    { label: "DNA/RNA Extract", value: LANDING_PAGE_STATIC_NUMBERS.bioBank.dnaRnaExtract },
    { label: "Tissue/FFPE Blocks", value: LANDING_PAGE_STATIC_NUMBERS.bioBank.ffpeBlocks },
    { label: "Plasma", value: LANDING_PAGE_STATIC_NUMBERS.bioBank.plasma },
  ],
  []
);



  /* ----------------------------------------
     JSX Return
  ---------------------------------------- */
  return (
    <div className="landing_page">
      {/* ----------------------------------------
         BANNER
      ---------------------------------------- */}
      <div className="banner">
        <div className="default">
          <img src={LandingImages.banner} alt="" />
        </div>

        {/* edited */}

        {/* <div className="banner_overlay">
          <div className="country_selected">
            <div
              className={`${selectedCountry.toLowerCase()} default highlighted`}
            >
              <img src={countryImages[selectedCountry]} alt={selectedCountry} />
            </div>
          </div>
        </div> */}

        {/* ----------------------------------------
           HEADER
        ---------------------------------------- */}
        <div className={scrolled ? "header scrolled" : "header"}>
          <div className="header_left">
            <img className="gcda_logo" alt="" src={LandingImages.gcdaLogo} />
          </div>

          <div className="header_right d-flex">
            {userDetails?.role === Roles.LUNG_ANALYST && (
              <div style={{ paddingRight: 10 }}>
                <button
                  type="button"
                  className="btn btn_style"
                  onClick={handleLungsAllianceClick}
                >
                  LuNGS Alliance
                </button>
              </div>
            )}

            {/* Dashboard button → non-GUEST, non-PATHOLOGY & non-LUNG */}
            {userDetails?.role !== Roles.GUEST_ANALYST &&
              userDetails?.role !== Roles.PATHOLOGY_ANALYST &&
              userDetails?.role !== Roles.LUNG_ANALYST && (
                <div style={{ paddingRight: 10 }}>
                  <button
                  type="button"
                  className="btn btn_style"
                  onClick={handleDashboardClick}
                >
                Dashboard
                  </button>
                </div>
              )}

            {/* 1K Dashboard button → everyone except DOCTOR_ANALYST & LUNG_ANALYST */}
            {userDetails?.role !== Roles.DOCTOR_ANALYST &&
              userDetails?.role !== Roles.LUNG_ANALYST && (
            <button
              type="button"
              className="btn btn-info btn_blue pathology_btn"
              style={{ marginRight: 10 }}
              onClick={handlePathologyClick}
            >
            {is1kViewEnabled ? "Home" : "1K Dashboard"}
            </button>
          )}

            <div className="dropdown">
              <button
                type="button"
                className="btn btn_blue gradient_btn"
                data-toggle="dropdown"
              >
                OV
              </button>
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={logout}>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Banner Patient Count */}
        <div className="line_chart">
          <div className="patient_number text-center">
            <div className="number_spans">
              <RollingCounter
                startValue={500}
                endValue={totalPatientCount}
                duration={2000}
              />
            </div>
            <h6>Patients</h6>
          </div>
        </div>

        {/* Banner Country States */}
        <div className="banner_countries">
          <div className="countries_list">
            <div className="item">
              <h1 className="mb-0">{LANDING_PAGE_STATIC_NUMBERS.banner.countries}</h1>
              <h5>Countries</h5>
            </div>

            <div className="item">
              <h1 className="mb-0">{LANDING_PAGE_STATIC_NUMBERS.banner.oncologists}</h1>
              <h5>Oncologists</h5>
            </div>

            <div className="item countryMarquee_space">
              <CountryMarquee
                countryImages={countryImages}
                countrieslist={countrieslist}
                // onActiveChange={setSelectedCountry}
              />
              <div className="lab-locations countryMarquee_shift_right">
                {/* <span className="dot_area"></span> */}
                <img className="dot_area" alt="" src={LocationMark} />
                <h6 className="mb-0 basespace">4baseCare Labs</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------
         Oncology Landscape Section
      ---------------------------------------- */}

      <div className="page_section">
        <div className="country_bg">
          <div className="onco_landscape">
            <h4 className="mb-4 text-left heading">Oncology Landscape</h4>

            <div className="row">
              {/* Top Cancer Sites */}
              <div className="col-lg-4 col-md-6 col-12">
                <div className="onco_card card glassy_card">
                  <div className="card_title p-20 border-bottom">
                    <h6>Top 10 Cancer Sites</h6>
                  </div>

                  <div className="card_inner p-20 pt-0 onco_list_scroll">
                    {top10Cancersite.map((item, index) => (
                      <div
                        key={index}
                        className={`list ${
                          index !== top10Cancersite.length - 1
                            ? "border_bottam"
                            : ""
                        }`}
                      >
                        <div className="cust_align py-3">
                          <span className="sl_no font_16">#{index + 1}</span>
                          <h6 className="mb-0 font_16" title={item.name}>
                            {item.name}
                          </h6>
                        </div>
                        <div className="num">
                          <h6 className="mb-0 font_16">{item.value}</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Morphology Distribution */}
              <div className="col-lg-4 col-md-6 col-12 mt_sm-30">
                <div className="onco_card card glassy_card">
                  <div className="card_title p-20 border-bottom">
                    <h6>Top 10 Genes Detected</h6>
                  </div>

                  <div className="card_inner p-20 pt-0 onco_list_scroll">
                    {top10BioMarkers?.map((biomarker, index) => (
                      <div
                        key={index}
                        className={`list ${
                          index !== top10BioMarkers.length - 1
                            ? "border_bottam"
                            : ""
                        }`}
                      >
                        <div className="cust_align py-3">
                          <span className="sl_no font_16">#{index + 1}</span>
                          <h6 className="mb-0 font_16" title={biomarker.name}>
                            {biomarker.name}
                          </h6>
                        </div>
                        <div className="num">
                          <h6 className="mb-0 font_16">{biomarker.totalCancerSiteCount}</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Clinico-genomic Box */}
              <div className="col-lg-4 col-md-12 col-12 mt_md-30">
                <div className="bg_blue-card">
                  <div className="onco_card card onco_3rd-card">
                    <div className="bg_card text-left">
                      <div className="p-20">
                        <div className="sec-1">
                          <h1>3M+</h1>
                          <h4 className="mb-0">Clinico-Genomic Parameters</h4>
                        </div>

                        <div className="dash_button">
                          {userDetails?.role === Roles.LUNG_ANALYST ? (
                            <button
                              type="button"
                              className="btn btn_blue btn_white"
                              onClick={handleLungsAllianceClick}
                            >
                              LuNGS Alliance <img alt="" src={dash_icon} />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn_blue btn_white"
                              onClick={handleDashboardClick}
                            >
                              Dashboard <img alt="" src={dash_icon} />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------------------
           Multi-Omics Section
        ---------------------------------------- */}
        <div className="multi_omics">
          <h4 className="mb-2 text-left heading">Multi-Omics Attributes</h4>
          <span className="txt_clr-2">
            Comprehensive genomic profiling through DNA and RNA sequencing,
            including Whole Exome and Targeted Panel analysis
          </span>

          <div className="row mt-4">
            {/* Genomics */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="card multi-omics_card bg_blue">
                <div className="card_head">
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={LANDING_PAGE_STATIC_NUMBERS.multiOmics.genomics.start}
                    end={LANDING_PAGE_STATIC_NUMBERS.multiOmics.genomics.total} 
                  />
                  <span className="cls_2">Genomics</span>
                </div>

                <div className="card_body my-2 pt-1">
                  <div className="left-sec pl-0">
                    <span>Whole Exome</span>
                    <span>{LANDING_PAGE_STATIC_NUMBERS.multiOmics.genomics.wholeExome}</span>
                  </div>

                  <div className="right-sec pr-0">
                    <span>Targeted</span>
                    <span>{LANDING_PAGE_STATIC_NUMBERS.multiOmics.genomics.targeted}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Transcriptomics */}
            <div className="col-lg-4 col-md-6 col-12 mt_sm-30">
              <div className="card multi-omics_card bg_purple">
                <div className="card_head">
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={LANDING_PAGE_STATIC_NUMBERS.multiOmics.transcriptomics.start}
                    end={LANDING_PAGE_STATIC_NUMBERS.multiOmics.transcriptomics.total}
                  />
                  <span className="cls_2">Transcriptomics</span>
                </div>

                <div className="card_body my-2 pt-1">
                  <div className="left-sec pl-0">
                    <span>Whole Exome</span>
                    <span>{LANDING_PAGE_STATIC_NUMBERS.multiOmics.transcriptomics.wholeExome}</span>
                  </div>
                  <div className="right-sec pr-0">
                    <span>Targeted</span>
                    <span>{LANDING_PAGE_STATIC_NUMBERS.multiOmics.transcriptomics.targeted}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Proteomics */}
            <div className="col-lg-4 col-md-12 col-12 mt_md-30">
              <div className="card multi-omics_card bg_dark-grren">
                <div className="card_head">
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={LANDING_PAGE_STATIC_NUMBERS.multiOmics.proteomics.start}
                    end={proteomics?.pdlMarkers}
                  />
                  <span className="cls_2">Proteomics</span>
                </div>

                <div className="card_body my-2 pt-1">
                  <div className="left-sec pl-0">
                    <span>PDL1</span>
                    <span>
                      {proteomics?.pdlMarkers
                        ? proteomics?.pdlMarkers.toLocaleString()
                        : 0}
                    </span>
                  </div>

                  <div className="right-sec pr-0">
                    <span>Other IHC</span>
                    <span>
                      {proteomics?.other
                        ? proteomics?.other.toLocaleString()
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------------------
           Golden Panel
        ---------------------------------------- */}
        <div className="">
          <div className="row">
            <div className="col">
              <div className="card card_1 p-20 golden_bg">
                <div className="box_inside">
                  <h4>
                    Comprehensive clinico-genomic dataset from non-Caucasian
                    cancer patients, bridging genetic insights with real-world
                    clinical outcomes to power inclusive precision oncology
                  </h4>

                  <div className="box_items">
                    <div className="item">
                      <span>
                        <img alt="" src={check} />
                      </span>
                      <span className="ml-2">
                        Longitudinal Real-World Evidence
                      </span>
                    </div>

                    <div className="item">
                      <span>
                        <img alt="" src={check} />
                      </span>
                      <span className="ml-2">Interoperable data formats</span>
                    </div>

                    <div className="item">
                      <span>
                        <img alt="" src={check} />
                      </span>
                      <span className="ml-2">Ontology-driven integration</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------------------
           Clinical Data Attributes
        ---------------------------------------- */}
        <div className="clinical_panel">
          <h4 className="mb-2 text-left heading">Clinical Data Attributes</h4>

          <div className="row mt-4">
            {/* Therapy Overview */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="card p-20 bg_box bg_box-1">
                <div className="card_head d-block">
                  <h4 className="mb-0 py-4">Therapy Overview</h4>
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={9000}
                    end={drugTotal}
                  />
                  <span className="cls_2 pl-0 ml-1">
                    Systemic &{" "}
                    <CountUpWrapper
                      duration={5}
                      className="cls_1"
                      start={10}
                      end={multiModal}
                    />{" "}
                    Multimodal
                  </span>
                </div>
              </div>
            </div>

            {/* Longitudinal Follow Up */}
            <div className="col-lg-4 col-md-6 col-12 mt_sm-30">
              <div className="card p-20 bg_box bg_box-2">
                <div className="card_head d-block">
                  <h4 className="mb-0 py-4">Avg.Longitudinal Follow-up</h4>
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={LANDING_PAGE_STATIC_NUMBERS.clinicalData.AvgLongitudinalFollowUpDays.start}
                    end={LANDING_PAGE_STATIC_NUMBERS.clinicalData.AvgLongitudinalFollowUpDays.end}
                  />
                  <span className="cls_2">Days</span>
                </div>
              </div>
            </div>

            {/* Multi-dimensional dataset */}
            <div className="col-lg-4 col-md-12 col-12 mt_md-30">
              <div className="card p-20 bg_box bg_box-3">
                <div className="card_head d-block">
                  <h4 className="mb-0 py-4">Multi-dimensional dataset</h4>
                  <CountUpWrapper
                    duration={5}
                    className="cls_1"
                    start={50}
                    end={primaryCanSite}
                  />
                  <span className="cls_2 pl-0 ml-1">
                    Cancer Types &&nbsp;<span className="cls_1">{LANDING_PAGE_STATIC_NUMBERS.clinicalData.MultiDimensionalClinicalData.value}</span>&nbsp;
                    Histologies
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------------------
           Charts Section (Treatment/Systemic/Bio)
        ---------------------------------------- */}
        <div className="graphs">
          <div className="row mt-4 therapy_section">
            {/* Treatment Distribution */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="card pie_card-1">
                <div className="card_head p-20 bac bac_1">
                  <h5 className="mb-0">Treatment Distribution</h5>
                </div>

                <div className="graph_body px-20">
                  <div className="graph_image">
                    {treatmentDetails ? (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions1}
                      />
                    ) : (
                      <Loader
                        type="spinner-circle"
                        bgColor="black"
                        title="spinner-circle"
                        color="#FFFFFF"
                        size={100}
                      />
                    )}
                  </div>

                  <div className="card_inner">
                    {treatmentDetails.map((treatment, index) => (
                      <div
                        key={index}
                        className={`list ${
                          index !== treatmentDetails.length - 1
                            ? "border_bottam"
                            : ""
                        }`}
                      >
                        <div className="cust_align py-3">
                          <span className="sl_no font_16">
                            <i
                              className="rounded_dot"
                              style={{
                                backgroundColor:
                                  colors10[index % colors10.length],
                              }}
                            ></i>
                          </span>
                          <h6 className="mb-0 font_16">{treatment.name}</h6>
                        </div>

                        <div className="num">
                          <h6 className="mb-0 font_16">{treatment.percent}%</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Systemic Therapy */}
            <div className="col-lg-4 col-md-6 col-12 mt_sm-30">
              <div className="card pie_card-2">
                <div className="card_head p-20 bac bac_2">
                  <h5 className="mb-0">Systemic Therapy</h5>
                </div>

                <div className="graph_body px-20">
                  <div className="graph_image">
                    {drugTherapy ? (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions}
                      />
                    ) : (
                      <Loader
                        type="spinner-circle"
                        bgColor="black"
                        title="spinner-circle"
                        color="#FFFFFF"
                        size={100}
                      />
                    )}
                  </div>

                  <div className="card_inner">
                    {drugTherapy.map((item, index) => (
                      <div
                        key={index}
                        className={`list ${
                          index !== drugTherapy.length - 1
                            ? "border_bottam"
                            : ""
                        }`}
                      >
                        <div className="cust_align py-3">
                          <span className="sl_no font_16">
                            <i
                              className="rounded_dot"
                              style={{
                                backgroundColor:
                                  colors11[index % colors11.length],
                              }}
                            ></i>
                          </span>
                          <h6 className="mb-0 font_16">{item.name}</h6>
                        </div>

                        <div className="num">
                          <h6 className="mb-0 font_16">{item.percent}%</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Biological Therapy */}
            <div className="col-lg-4 col-md-6 col-12 mt_md-30">
              <div className="card pie_card-3">
                <div className="card_head p-20 bac bac_3">
                  <h5 className="mb-0">Biological Therapy</h5>
                </div>

                <div className="graph_body px-20">
                  <div className="graph_image">
                    {biologicalTherapy ? (
                      <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions2}
                      />
                    ) : (
                      <Loader
                        type="spinner-circle"
                        bgColor="black"
                        title="spinner-circle"
                        color="#FFFFFF"
                        size={100}
                      />
                    )}
                  </div>

                  <div className="card_inner">
                    {biologicalTherapy.map((item, index) => (
                      <div
                        key={index}
                        className={`list ${
                          index !== biologicalTherapy.length - 1
                            ? "border_bottam"
                            : ""
                        }`}
                      >
                        <div className="cust_align py-3">
                          <span className="sl_no font_16">
                            <i
                              className="rounded_dot"
                              style={{
                                backgroundColor:
                                  colors12[index % colors12.length],
                              }}
                            ></i>
                          </span>
                          <h6 className="mb-0 font_16">{item.name}</h6>
                        </div>

                        <div className="num">
                          <h6 className="mb-0 font_16">{item.percent}%</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ----------------------------------------
           Biobank
        ---------------------------------------- */}
        <div className="text-left">
          <h4 className="mb-2 text-left heading">Biobank</h4>
          <span className="txt_clr-2">
          A large, curated repository of genomically annotated biospecimens driving multimodal oncology insights
          </span>


          <div className="row mt-4">
            <div className="col-lg-8">
              <div className="card bio_card bio_card-1"></div>
            </div>

            <div className="col-lg-4">
              <div className="card bio_card">
              <div className="bio_card-inner">
                <div className="card_inner biobank_metrics">
                  {biobankMetrics.map((item, index) => (
                    <div className="bio-metric-row" key={index}>
                      <span className="bio-metric-label">{item.label}</span>
                      <span className="bio-metric-count">
                        {item.value.toLocaleString("en-US")}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
             </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------
         Footer
      ---------------------------------------- */}
      <Footer />
    </div>
  );
};

export default Landing;
